export const KEY = 'swy_publish_notice_state';

// 从 sessionStorage 读取“发布催告”流程的跨步骤状态（选择债务人、模板、编辑内容、签章配置等）
export const loadState = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || '{}');
  } catch (_) {
    return {};
  }
};

// 合并写入 sessionStorage：用于在不同步骤间增量保存字段，避免覆盖其它步骤已写入的数据
export const saveState = (next) => {
  const prev = loadState();
  sessionStorage.setItem(KEY, JSON.stringify({ ...prev, ...next }));
};

// 对对象做稳定序列化：避免 key 顺序导致的签名变化
// 用于把 pageSettings 等对象转成可重复计算的字符串
const stableStringify = (val) => {
  if (val === null) return 'null';
  const t = typeof val;
  if (t === 'string') return JSON.stringify(val);
  if (t === 'number' || t === 'boolean') return String(val);
  if (t !== 'object') return '';
  if (Array.isArray(val)) return `[${val.map(stableStringify).join(',')}]`;
  const keys = Object.keys(val).sort();
  return `{${keys.map((k) => `${JSON.stringify(k)}:${stableStringify(val[k])}`).join(',')}}`;
};

// 轻量哈希：用于将“模板正文 + 页面设置”压缩成短签名，便于与旧位置/配置做绑定校验
// 注意：这里不是加密用途，仅用于变更检测
const fnv1a32Hex = (input) => {
  const str = String(input || '');
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i += 1) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
};

export const computeNoticeContentSig = (contentHtml, pageSettings) => {
  // pageSettings 与 contentHtml 任一变化，都应使签名变化，从而让旧签章偏移失效并触发重新计算
  const ps = stableStringify(pageSettings || {});
  const body = String(contentHtml || '');
  return `v1:${fnv1a32Hex(`${ps}\n${body}`)}`;
};

/**
 * 校验 sessionStorage 中的签章偏移是否仍可复用
 * - sig 必须与当前“内容签名”一致（内容或页面设置变更会导致 sig 变化）
 * - sealOffsetRightMm / sealOffsetBottomMm 必须是可解析的有限数值
 *
 * noticeContentSig 可选：调用方若已计算过签名，传入可避免重复计算
 */
export const isStoredSealOffsetsValid = ({
  contentHtml,
  pageSettings,
  noticeContentSig,
  sealOffsetsSig,
  sealOffsetRightMm,
  sealOffsetBottomMm,
}) => {
  const sig = String(noticeContentSig || computeNoticeContentSig(contentHtml, pageSettings));
  const matches = String(sealOffsetsSig || '') && String(sealOffsetsSig) === String(sig);
  const isFiniteNumberLike = (v) => v !== null && v !== undefined && v !== '' && Number.isFinite(Number(v));
  return matches && isFiniteNumberLike(sealOffsetRightMm) && isFiniteNumberLike(sealOffsetBottomMm);
};
